import { useEffect } from 'react'

export default function DrawerShell({
  open = false,
  title = '',
  subtitle = '',
  onClose,
  children
}) {
  useEffect(() => {
    if (!open) return undefined

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose?.()
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [onClose, open])

  if (!open) return null

  return (
    <section className="gg-drawer-shell" role="dialog" aria-modal="true" aria-label={title || 'Detail drawer'}>
      <button type="button" className="gg-drawer-shell__backdrop" onClick={() => onClose?.()} aria-label="Close detail drawer" />
      <aside className="gg-drawer-shell__panel">
        <header className="gg-drawer-shell__head">
          <div>
            {title ? <h3 className="gg-drawer-shell__title">{title}</h3> : null}
            {subtitle ? <p className="gg-drawer-shell__subtitle">{subtitle}</p> : null}
          </div>
          <button type="button" className="gg-button gg-button--ghost" onClick={() => onClose?.()}>
            Close
          </button>
        </header>
        {children}
      </aside>
    </section>
  )
}
